import React from 'react';
import { Typography, Statistic, Card, Divider } from 'antd';
import { HomeOutlined, CustomerServiceOutlined, TeamOutlined, SafetyCertificateOutlined, TrophyOutlined } from '@ant-design/icons';
import './AboutPage.css';

const { Title, Paragraph, Text } = Typography;

const AboutPage: React.FC = () => {

  const coreValues = [
    {
      icon: <SafetyCertificateOutlined className="value-icon" />,
      title: '品质保证',
      description: '严格的质量控制体系，使用优质材料，确保装修质量'
    },
    {
      icon: <TeamOutlined className="value-icon" />,
      title: '专业团队',
      description: '专业设计师和施工团队，从设计到施工全程把控'
    },
    {
      icon: <CustomerServiceOutlined className="value-icon" />,
      title: '贴心服务',
      description: '24小时响应，定期回访，让您装修更省心'
    }
  ];

  return (
    <div className="about-page">
      <div className="container">
        <Title level={1} className="page-title">关于我们</Title>
        <Paragraph className="page-subtitle">
          专业的装修服务平台，为您提供优质的装修体验
        </Paragraph>

        <Divider />

        {/* 公司简介 */}
        <div className="intro-section">
          <Title level={2}>公司简介</Title>
          <Paragraph className="intro-text">
            同步到家是一家专注于装修服务的互联网平台，隶属赣州赣晋贸易有限公司，成立于2021年。我们致力于为用户提供一站式的装修服务，
            包括找装修公司、买装修材料、找装修师傅等全方位服务。通过严格的品控体系和优质的服务团队，
            我们已服务超过10000个家庭，获得了用户的一致好评。
          </Paragraph>
          <Paragraph className="intro-text">
            我们的使命是让装修变得简单、透明、省心。通过互联网技术，我们打破了传统装修行业的信息不对称，
            让用户可以轻松找到合适的装修服务，享受专业的装修体验。
          </Paragraph>
        </div>

        <Divider />

        {/* 数据统计 */}
        <div className="stats-section">
          <Title level={2}>我们的成就</Title>
          <div className="stats-grid">
            <Card className="stat-card" variant="borderless">
              <Statistic
                title="服务家庭"
                value={10000}
                suffix="+"
                prefix={<HomeOutlined className="stat-icon" />}
                valueStyle={{ color: 'var(--primary-color)' }}
              />
            </Card>
            <Card className="stat-card" variant="borderless">
              <Statistic
                title="完成项目"
                value={8000}
                suffix="+"
                prefix={<TrophyOutlined className="stat-icon" />}
                valueStyle={{ color: 'var(--secondary-color)' }}
              />
            </Card>
            <Card className="stat-card" variant="borderless">
              <Statistic
                title="专业团队"
                value={150}
                suffix="人"
                prefix={<TeamOutlined className="stat-icon" />}
                valueStyle={{ color: 'var(--success-color)' }}
              />
            </Card>
            <Card className="stat-card" variant="borderless">
              <Statistic
                title="用户满意度"
                value={98}
                suffix="%"
                prefix={<SafetyCertificateOutlined className="stat-icon" />}
                valueStyle={{ color: 'var(--info-color)' }}
              />
            </Card>
          </div>
        </div>

        <Divider />

        {/* 核心价值
        <div className="values-section">
          <Title level={2}>核心价值</Title>
          <div className="values-grid">
            {coreValues.map((value, index) => (
              <Card key={index} className="value-card" variant="borderless" hoverable>
                {value.icon}
                <Title level={4} className="value-title">{value.title}</Title>
                <Paragraph className="value-description">{value.description}</Paragraph>
              </Card>
            ))}
          </div>
        </div>

        <Divider /> */}

        {/* 企业文化 */}
        <div className="culture-section">
          <Title level={2}>企业文化</Title>
          <div className="culture-content">
            <Paragraph className="culture-text">
              <strong>使命：</strong>让每个家庭都能享受到专业、透明、省心的装修服务
            </Paragraph>
            <Paragraph className="culture-text">
              <strong>愿景：</strong>成为最值得信赖的装修服务平台
            </Paragraph>
            <Paragraph className="culture-text">
              <strong>价值观：</strong>用户至上、专业诚信、品质保障、创新进取
            </Paragraph>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutPage;
